import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import AdminLayout from "./layouts/AdminLayout";
import TechLayout from "./layouts/TechLayout";

import AdminDashboard from "./pages/admin/Dashboard";
import Customers from "./pages/admin/Customers";
import CustomerDetail from "./pages/admin/CustomerDetail";
import Jobs from "./pages/admin/Jobs";
import JobDetail from "./pages/admin/JobDetail";
import Technicians from "./pages/admin/Technicians";
import Brands from "./pages/admin/Brands";
import SpareParts from "./pages/admin/SpareParts";
import Appointments from "./pages/admin/Appointments";
import { homeFor } from "./lib/areas";
import Accounting from "./pages/admin/Accounting";
import Reports from "./pages/admin/Reports";
import Settings from "./pages/admin/Settings";
import AdminQuotes from "./pages/admin/Quotes";
import Visitors from "./pages/admin/Visitors";
import Messages from "./pages/admin/Messages";
import Dealers from "./pages/admin/Dealers";
import Warranty from "./pages/admin/Warranty";
import Reviews from "./pages/admin/Reviews";
import Announcements from "./pages/admin/Announcements";
import Performance from "./pages/admin/Performance";
import AdminUsers from "./pages/admin/AdminUsers";
import Integration from "./pages/admin/Integration";
import Diagnosis from "./pages/admin/Diagnosis";
import Track from "./pages/Track";
import TechDiagnosis from "./pages/tech/Diagnosis";
import SiteStudio from "./pages/admin/SiteStudio";
import Media from "./pages/admin/Media";
import Security from "./pages/admin/Security";
import Account from "./pages/admin/Account";
import Governance from "./pages/admin/Governance";
import Growth from "./pages/admin/Growth";
import Marketing from "./pages/admin/Marketing";
import Team from "./pages/admin/Team";
import DevicePublic from "./pages/DevicePublic";
import DealerPortal from "./pages/DealerPortal";
import Shop from "./pages/admin/Shop";
import SiteFeatures from "./pages/admin/SiteFeatures";
import CouponsPage from "./pages/admin/Coupons";
import TechChat from "./pages/tech/Chat";
import TechMore from "./pages/tech/More";

import MyJobs from "./pages/tech/MyJobs";
import TechJobDetail from "./pages/tech/TechJobDetail";
import MyBalance from "./pages/tech/MyBalance";
import TechProfile from "./pages/tech/TechProfile";
import TechQuotes from "./pages/tech/Quotes";
import TechAnnouncements from "./pages/tech/Announcements";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? homeFor(user) : "/tech"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/takip/:token" element={<Track />} />
            <Route path="/bayi-portal/:token" element={<DealerPortal />} />
            <Route path="/cihaz/:token" element={<DevicePublic />} />

            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="jobs/:id" element={<JobDetail />} />
              <Route path="technicians" element={<Technicians />} />
              <Route path="brands" element={<Brands />} />
              <Route path="parts" element={<SpareParts />} />
              <Route path="appointments" element={<Appointments />} />
              <Route path="accounting" element={<Accounting />} />
              <Route path="quotes" element={<AdminQuotes />} />
              <Route path="reports" element={<Reports />} />
              <Route path="visitors" element={<Visitors />} />
              <Route path="messages" element={<Messages />} />
              <Route path="dealers" element={<Dealers />} />
              <Route path="warranty" element={<Warranty />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="announcements" element={<Announcements />} />
              <Route path="performance" element={<Performance />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="integration" element={<Integration />} />
              <Route path="settings" element={<Settings />} />
              <Route path="site-studio" element={<SiteStudio />} />
              <Route path="media" element={<Media />} />
              <Route path="diagnosis" element={<Diagnosis />} />
              <Route path="security" element={<Security />} />
              <Route path="account" element={<Account />} />
              <Route path="governance" element={<Governance />} />
              <Route path="growth" element={<Growth />} />
              <Route path="coupons" element={<CouponsPage />} />
              <Route path="shop" element={<Shop />} />
              <Route path="site-features" element={<SiteFeatures />} />
              <Route path="marketing" element={<Marketing />} />
              <Route path="team" element={<Team />} />
            </Route>

            <Route path="/tech" element={<ProtectedRoute role="technician"><TechLayout /></ProtectedRoute>}>
              <Route index element={<MyJobs />} />
              <Route path="jobs/:id" element={<TechJobDetail />} />
              <Route path="quotes" element={<TechQuotes />} />
              <Route path="announcements" element={<TechAnnouncements />} />
              <Route path="diagnosis" element={<TechDiagnosis />} />
              <Route path="balance" element={<MyBalance />} />
              <Route path="profile" element={<TechProfile />} />
              <Route path="chat" element={<TechChat />} />
              <Route path="more" element={<TechMore />} />
            </Route>

            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
